import { RouterProvider } from "react-router-dom";

import { router } from "./routes";

import { useEffect } from "react";

import signalRService from "../services/SignalrService";

import { Toaster } from "../components/common/toast";
import { BlockedActionModalHost } from "../components/common/BlockedActionModalHost";

export default function App() {

  useEffect(() => {

    console.log(
      "🚀 APP INITIALIZED"
    );

    const token =
      localStorage.getItem("accessToken") || "";

    signalRService.startConnection(token);

    return () => {
      signalRService.stopConnection();
    };

  }, []);

  return (
    <>
      <RouterProvider router={router} />

      <Toaster />

      <BlockedActionModalHost />
    </>
  );
}